import Vue from 'vue';
import '../static/config';
import AxiosPlugin from './js/lib/axiosPlugin';
import API from './js/interface/index';
import router from './router';
import App from './App';
import store from './store';
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import sensors from 'sa-sdk-javascript'
//引入阿里巴巴iconfont
import './assets/css/iconfont/iconfont.css';

import './assets/css/reset.scss';

import { VueJsonp } from 'vue-jsonp';

Vue.use(VueJsonp);

let scURL = ''
// 测试环境、开发环境不上报
if (process.env.ENV === 'testing' || process.env.NODE_ENV === 'development') {
  window.gtag = () => { };
  scURL = 'https://dataaccess.renogy.cn/sa?project=default'
} else {
  scURL = 'https://dataaccess.renogy.cn/sa?project=production'
}
const userToken = localStorage.getItem("userToken");
const isLogin = userToken ? true : false
sensors.init({
  server_url: scURL,
  is_track_single_page: function () {
    return true
  }, // 单页面配置，默认开启，若页面中有锚点设计，需要将该配置删除，否则触发锚点会多触发 $pageview 事件
  use_client_time: true,
  send_type: 'beacon',
  // show_log: import.meta.env.MODE === 'dev',
  show_log: true,
  heatmap: {
    collect_tags: {
      // img: true,
    },
    //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
    clickmap: 'default',
    //是否开启触达图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
    scroll_notice_map: 'default',
  },
})
sensors.registerPage({
  platform_type: 'calculator',
  is_login: isLogin,
})
sensors.quick('autoTrack', {
  platform_type: 'calculator',
  is_login: isLogin,
}) //用于采集 $pageview 事件。

//国际化
// import i18n from '@/js/i18n/i18n';
// Vue.use(i18n)

Vue.use(ViewUI);

Vue.use(AxiosPlugin);

Vue.config.productionTip = false;
Vue.prototype.$sensors = sensors

window.API = API;//把引入统一管理接口页面挂在全局对象window.API下面

new Vue({
  el: '#app',
  router,
  store,
  // i18n,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js